import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Button,
  Modal,
  Form,
  Input,
  Spin,
  message,
} from "antd";

import { PlusOutlined,SearchOutlined,
    CloseOutlined, } from "@ant-design/icons";
import useApis from "../apis/useApis";
import appConstant from "../json/appConstant.json";

const Mohallas = ({ isDarkMode }) => {
  const [form] = Form.useForm();
  const [mohallaData, setMohallaData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
 const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  const { jsonApi } = useApis();

  useEffect(() => {
    fetchMohallas();
  }, [pagination.current, search]);

//   useEffect(() => {
//     if (!searchText) {
//       setMohallaData(originalData);
//     } else {
//       const lower = searchText.toLowerCase();
//       const filtered = originalData.filter(
//         (item) =>
//           item.name.toLowerCase().includes(lower) ||
//           item.nameH.toLowerCase().includes(lower)
//       );
//       setMohallaData(filtered);
//     }
//   }, [searchText, originalData]);

  const fetchMohallas = async () => {
    setIsDataLoading(true);
    
    try {

        const params = {
            // page: pagination.current,
            // pageSize: pagination.pageSize,
            search,
          };
      const response = await jsonApi(appConstant.Mohalla,  params, {}, null);
      if (response.data.code === 200 && response.data.status === "success") {
        const data = response.data.data.map((item) => ({
          key: item.Id,
          id: item.Id,
          name: item.MohallaName,
          nameH: item.MohallaNameH,
          wardId: item.M_WardMaster.WardName,
          transDate: item.TransDate,
          isActive: item.IsActive,
        }));
        setOriginalData(data);
        setMohallaData(data);
      }
    } catch (error) {
      message.error("Failed to load mohalla data");
    } finally {
      setIsDataLoading(false);
    }
  };

  const handleAddMohalla = async (values) => {
    setLoading(true);
    try {
      const payload = {
        MohallaName: values.MohallaName,
        MohallaNameH: values.MohallaNameH,
        WardID: values.WardID,
      };

      const response = await jsonApi(appConstant.createMohalla, null, payload, null);

      if (response.data?.code === 200 || response.data?.status === "success") {
        message.success("Mohalla added successfully");
        setIsModalVisible(false);
        form.resetFields();
        fetchMohallas();
      } else {
        message.error(response.data?.message || "Failed to add mohalla");
      }
    } catch (error) {
      message.error("Error while creating mohalla");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
    },
    {
      title: "Mohalla Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Mohalla Name (Hindi)",
      dataIndex: "nameH",
      key: "nameH",
    },
    {
      title: "Ward",
      dataIndex: "wardId",
      key: "wardId",
    },
    {
      title: "Transaction Date",
      dataIndex: "transDate",
      key: "transDate",
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Is Active",
      dataIndex: "isActive",
      key: "isActive",
      render: (val) => (val ? "Yes" : "No"),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: 16,
        }}
      >
        <h2 style={{ marginBottom: 8, color: isDarkMode ? "#fff" : "#000" }}>
          Mohalla List
        </h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsModalVisible(true)}
        >
          Add Mohalla
        </Button>
      </div>

      <Input
        placeholder="Search wards..."
        prefix={<SearchOutlined />}
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPagination((prev) => ({ ...prev, current: 1 }));
        }}
        suffix={
          search && (
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={() => {
                setSearch("");
                setPagination((prev) => ({ ...prev, current: 1 }));
              }}
            />
          )
        }
        style={{ marginBottom: 16, width: 300 }}
      />

      <Card
        style={{
          background: isDarkMode ? "#1f1f1f" : "#ffffff",
          borderColor: isDarkMode ? "#303030" : "#f0f0f0",
        }}
      >
        <Spin spinning={isDataLoading}>
          <Table
            columns={columns}
            dataSource={mohallaData}
            pagination={{ pageSize: 10 }}
            rowKey="id"
          />
        </Spin>
      </Card>

      <Modal
        title="Add Mohalla"
        visible={isModalVisible}
        onCancel={() => {
          form.resetFields();
          setIsModalVisible(false);
        }}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleAddMohalla}>
          <Form.Item
            label="Mohalla Name"
            name="MohallaName"
            rules={[{ required: true, message: "Please enter Mohalla Name" }]}
          >
            <Input placeholder="Enter Mohalla Name" />
          </Form.Item>

          <Form.Item
            label="Mohalla Name (Hindi)"
            name="MohallaNameH"
            rules={[{ required: true, message: "Please enter Mohalla Name in Hindi" }]}
          >
            <Input placeholder="Enter Mohalla Name in Hindi" />
          </Form.Item>

          <Form.Item
            label="Ward ID"
            name="WardID"
            rules={[{ required: true, message: "Please enter Ward ID" }]}
          >
            <Input type="number" placeholder="Enter Ward ID" />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button type="primary" htmlType="submit" loading={loading}>
              Add Mohalla
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Mohallas;
